import { BRAVEMOVE_PALETTES } from './tokens/palettes';
import { BRAVEMOVE_TYPE, BRAVEMOVE_SIZE } from './tokens/typography';
import { BRAVEMOVE_SPACE } from './tokens/space';
import { BRAVEMOVE_RADIUS } from './tokens/radius';
import { BRAVEMOVE_SHADOW } from './tokens/shadow';
import { BRAVEMOVE_MOTION } from './tokens/motion';
import { BRAVEMOVE_ICONS, BRAVEMOVE_ICON_SIZE } from './tokens/icons';
import type { Mode, PaletteKey, Team, Tokens } from './tokens/types';

const cache = new Map<PaletteKey, Tokens>();

function teamFor(key: PaletteKey): Team {
  return key.startsWith('garnet') ? 'w' : 'm';
}

function modeFor(key: PaletteKey): Mode {
  return key.endsWith('_dark') ? 'dark' : 'light';
}

/**
 * Build the immutable token set for a palette key. Memoized: same key
 * returns the same frozen object on every call.
 */
export function bravemoveTokens(paletteKey: PaletteKey = 'garnet_light'): Tokens {
  const cached = cache.get(paletteKey);
  if (cached) return cached;

  const color = BRAVEMOVE_PALETTES[paletteKey];
  if (!color) {
    throw new Error(`Unknown BraveMove palette: ${String(paletteKey)}`);
  }

  const tokens: Tokens = Object.freeze({
    key: paletteKey,
    mode: modeFor(paletteKey),
    team: teamFor(paletteKey),
    color,
    type: BRAVEMOVE_TYPE,
    size: BRAVEMOVE_SIZE,
    icon: BRAVEMOVE_ICONS,
    iconSize: BRAVEMOVE_ICON_SIZE,
    space: BRAVEMOVE_SPACE,
    radius: BRAVEMOVE_RADIUS,
    shadow: BRAVEMOVE_SHADOW,
    motion: BRAVEMOVE_MOTION,
  });

  cache.set(paletteKey, tokens);
  return tokens;
}
